export default __webpack_public_path__ + "static/media/iso.4113d855.svg";